import { ICheckItemTemplateListVM } from '../../models/response/ICheckItemTemplateResponse';

export const GetAllCheckItemTemplateInitialState: ICheckItemTemplateListVM = {
    CheckItems: [],
    PagingDetails: {
        CurrentPage: 1,
        PageSize: 100,
        TotalPages: 0,
        TotalRecords: 0
    }
};

export default GetAllCheckItemTemplateInitialState;
